export default function IncludesIgnoreCase (target, searchString = '') {
  if (target == null) return false
  return target.toString().toLowerCase().includes(searchString.toLowerCase())
}
